import React from "react";
import "components/SquareCheckBox/squareCheckBox.scss";

const SquareCheckBox = ({
  labelStyles = {},
  label,
  isChecked,
  handleCheck = () => {},
  isDisable,
  ...props
}) => {
  return (
    <label className="checkbox-container" style={labelStyles}>
      <input
        disabled={isDisable}
        type="checkbox"
        checked={isChecked}
        onChange={(e) => handleCheck(e, label)}
        {...props}
      />
      <span
        className={`checkMark ${isChecked ? "checked" : ""} ${isDisable ? "disableCheckBox" : ""}`}
      ></span>
      {label}
    </label>
  );
};

export default SquareCheckBox;
